export class ResultModel {

  result: Map<string, string[]> = new Map<string, string[]>();

  constructor(result: Map<string, string[]>) {
    this.result = result;
  }

}
